import { useEffect, useMemo } from 'react';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';
import { captureException } from '@sentry/browser';
import { ErrorModal } from 'src/modules/common/components/ErrorModal/ErrorModal';
import { SkeletonMainLayout } from 'src/modules/common/skeletons/SkeletonMainLayout/SkeletonMainLayout';

export const ErrorBoundary = () => {
    const routerError = useRouteError();

    const error = useMemo(() => {
        if (isRouteErrorResponse(routerError)) {
            return {
                name: routerError.status,
                message: routerError.statusText,
                stack: JSON.stringify(routerError.data),
                components: null,
            };
        }

        if (routerError instanceof Error) {
            return {
                name: routerError.name,
                message: routerError.message,
                stack: routerError.stack,
                components: null,
            };
        }

        if (typeof routerError === 'string') {
            return {
                name: routerError,
                message: null,
                stack: null,
                components: null,
            };
        }

        return {
            name: 'Unknown error',
            message: null,
            stack: null,
            components: null,
        };
    }, [routerError]);

    useEffect(() => {
        if (routerError) {
            captureException(routerError);

            // eslint-disable-next-line no-console
            console.warn(routerError, error);
        }
    }, [routerError, error]);

    return (
        <SkeletonMainLayout idle={true}>
            <div className="vss-error-boundary">
                <ErrorModal/>
            </div>
        </SkeletonMainLayout>
    );
};
